import {useQuery} from "@tanstack/react-query";
import {readPaymentSelectBox} from "../../../../../api/order/OrdersApi";

export const useReadPaymentSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readPaymentSelectBox"],
        queryFn: async () => await readPaymentSelectBox(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
